export const filterSelect = (rows:any, columnIds:any, filterOpts: any):boolean => {
	const dbLoc = filterOpts?.meta?.databaseLocation ?? columnIds;
	const { value } = filterOpts;
	return value === rows.original[dbLoc];
}
